import { Button } from 'react-bootstrap';
import { TableWrapper } from './styles';

interface IProps {
    list: any[]
}

const DonorsMissingLdPriorization = (props: IProps) => {
    return (
        <TableWrapper className='table table-condensed table-striped table-bordered'>
            <thead>
                <tr style={{ backgroundColor: '#ddd' }}>
                    <th>Center</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th style={{ width: '25%' }}>Surgery Date</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.list.map((item, index) =>
                    <tr key={'tr-' + index}>
                        <td>{item.centerAlias}</td>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.email}</td>
                        <td>{item.closeLoopSurgeryDateTime}</td>
                        <td><Button bsStyle='primary' bsSize='xs' href={`/center/${item.centerId}/donors/donor-intake/details/${item.registrationId}`} target='_blank'>Details</Button></td>
                    </tr>
                )}
            </tbody>
        </TableWrapper>
    );
}

export default DonorsMissingLdPriorization;